import { useController, UseControllerProps } from 'react-hook-form';
import { RangeBlocks } from '../../base-components';
import {
    createScoreRangeConfig,
    IRangeBlocksValues,
    ScoreRange,
} from '../../../common';

interface Props extends UseControllerProps {
    disabled?: boolean;
    fillColor?: string;
    backgroundColor?: string;
    customRanges?: Array<ScoreRange>;
    showSelectionText?: boolean;
    selectMaxOnly?: boolean;
}

const FormRangeBlocks = ({
    disabled = false,
    fillColor = '#22c55e',
    backgroundColor = '#e5e7eb',
    customRanges,
    showSelectionText = true,
    selectMaxOnly = false,
    ...props
}: Props) => {
    const { field } = useController(props);
    const scoreRangeConfig = createScoreRangeConfig(customRanges);

    const handleChange = (newValue: IRangeBlocksValues) => {
        field.onChange(newValue);
    };

    return (
        <>
            <RangeBlocks
                externalValue={field.value}
                onChange={handleChange}
                disabled={disabled}
                fillColor={fillColor}
                backgroundColor={backgroundColor}
                scoreRangeConfig={scoreRangeConfig}
                showSelectionText={showSelectionText}
                selectMaxOnly={selectMaxOnly}
            />
        </>
    );
};

export default FormRangeBlocks;
